import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useParams } from 'next/navigation';
import { localeMapping } from 'helpers/constants/localeMapping';

export interface FooterLink {
  title: string;
  href: string;
}

export interface Props {
  header?: string;
  links: FooterLink[];
  className?: string;
}

const Column: React.FC<Props> = ({ header, links, className }) => {
  
  return (
    <div className={className}>
      <ul role="list" className="mb-3 flex flex-row flex-wrap items-start mt-10 gap-x-8 self-start">
        {links.map((item, i) => (
          <li key={i} className="inline-block">
            <Link variant="primary" link={item.href} target={item?.href?.includes("https://") ? '_blank' : ''} className="text-white hover:text-[#B3B3B3]">
              <Typography className="inline-block">
                {item.title}
              </Typography>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Column;
